<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="v_tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      :seq-config="{ seqMethod }"
      row-id="soBillDetailCode"
      :span-method="mergeRowMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createByName="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createTime }}</span>
        </div>
      </template>
      <template v-slot:modifyByName="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyTime }}</span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            v-allow="'actBack'"
            placement="top"
          >
            <i
              class="el-icon-refresh-left  tool-btn"
              @click="batchBack([row.soBillCode])"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:bigTrayCount="{ row }">
        <div>
          {{ row.bigTrayCount ? row.bigTrayCount : '-' }}
        </div>
      </template>
      <template v-slot:smTrayCount="{ row }">
        <div>
          {{ row.smTrayCount ? row.smTrayCount : '-' }}
        </div>
      </template>
      <template v-slot:cartonCount="{ row }">
        <div>
          {{ row.cartonCount ? row.cartonCount : '-' }}
        </div>
      </template>
      <template v-slot:count="{ row }">
        <div>
          {{
            (row.cartonCount || 0) +
              (row.smTrayCount || 0) +
              (row.bigTrayCount || 0)
          }}
        </div>
      </template>
      <template v-slot:otherFee="{ row }">
        <div>
          <el-link type="primary" @click="showFeeDetail(row)">{{
            row.otherFee
          }}</el-link>
        </div>
      </template>
    </vxe-grid>

    <ExpenseDetails
      ref="expenseDetails"
      v-if="feeDialogOption.dialogVisible"
      :soBillDetailCode="feeDialogOption.soBillDetailCode"
      :soBillDetailCodeList="feeDialogOption.soBillDetailCodeList"
      :soBillCodeList="feeDialogOption.soBillCodeList"
      :title="feeDialogOption.title"
      :type="feeDialogOption.type"
      :show="feeDialogOption.show"
      :dialogVisible.sync="feeDialogOption.dialogVisible"
      @close="close"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import ExpenseDetails from '../expenseDetails.vue'
const field = [
  'otherFee',
  'incomeTotalAmount',
  'payAmount',
  'soBillNo',
  'soBillCode',
  'chargeableWeight',
  'contractUnitPrice',
  'incomeFreightAmount',
  'contractMinAmount',
  'vehicleUnloadingFee',
  'tallyFee',
  'upstairsFee',
  'carOne',
  'carTwo',
  'carThree',
  'carFour',
  'carFive',
  'carCount',
]
export default {
  components: { ExpenseDetails },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      v_tableData: [],
      mergeFields: ['contractName', 'contractCarrierName', ...field],
      mergeField: [...field],
      fullScreenLoading: false,
      feeDialogOption: {
        dialogVisible: false,
        soStatementCode: '',
        soStatementCodeList: [],
      },
      span: { rowspan: 0, colspan: 0 },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        let data = []
        if (e && e.length > 0) {
          e.forEach((f) => {
            data.push(...f.soBillDetailList)
          })
        }
        this.v_tableData = data
      },
    },
  },
  computed: {},
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 242
    },
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const property = column.property || ''
      const cellValue = row[property]
      if (cellValue && this.mergeFields.includes(property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]

        const preFlag = prevRow
          ? prevRow[property] === cellValue &&
            prevRow.soBillCode == row.soBillCode
          : false
        if (this.mergeField.includes(property)) {
          if (preFlag) {
            return this.span
          } else {
            let countRowspan = 1
            while (
              nextRow &&
              nextRow[property] === cellValue &&
              nextRow.soBillCode == row.soBillCode
            ) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        } else if (property == 'contractCarrierName') {
          if (
            preFlag &&
            prevRow.contractCarrierCode == row.contractCarrierCode
          ) {
            return this.span
          } else {
            let countRowspan = 1
            while (
              nextRow &&
              nextRow[property] === cellValue &&
              nextRow.contractCarrierCode == row.contractCarrierCode &&
              nextRow.soBillCode == row.soBillCode
            ) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        } else if (property == 'contractName') {
          if (preFlag && prevRow.contractCode == row.contractCode) {
            return this.span
          } else {
            let countRowspan = 1
            while (
              nextRow &&
              nextRow[property] === cellValue &&
              nextRow.contractCode == row.contractCode &&
              nextRow.soBillCode == row.soBillCode
            ) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
    seqMethod(params) {
      const seq = (this.tablePage.curPage - 1) * this.tablePage.pageSize + 1

      const { row, column, visibleData } = params
      const { property } = column
      if (property === 'soBillCode') {
        let group = []
        visibleData.forEach((i) => {
          if (group.indexOf(i.soBillCode) < 0) {
            group.push(i.soBillCode)
          }
        })
        return group.indexOf(row.soBillCode) + seq
      }
      const groupRow = visibleData.filter(
        (i) => i.soBillCode === row.soBillCode
      )
      return (
        groupRow.findIndex((i) => i.soBillDetailCode === row.soBillDetailCode) +
        seq
      )
    },

    getTableCheckedData() {
      return this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
    },
    batchOperations(formData) {
      const { type, form } = formData
      const data = this.getTableCheckedData()
      if (data === null || data === [] || data.length === 0) {
        if (type == 'batchExport') {
          this.batchExport([], form)
          return
        }
        this.$message({
          message: '请选择您要操作的数据！',
          type: 'warning',
        })
        return
      }
      const soBillCodeList = [
        ...new Set(
          data.map((row) => {
            return row.soBillCode
          })
        ),
      ]
      switch (type) {
        case 'batchExport':
          this.batchExport(soBillCodeList)
          break
        case 'batchBack':
          this.batchBack(soBillCodeList)
          break
      }
    },

    batchExport(soBillCodeList, form) {
      const url = '/finance/fin/so/statement/export'
      const param = {
        codeList: soBillCodeList,
        ...form,
      }
      let fileName = 'SO账单导出（已结算）'
      this.$api.globalExportData(url, param, fileName)
    },
    batchBack(soBillCodeList) {
      this.fullScreenLoading = true
      this.$api
        .finSoBillBatchBackApi({
          soBillCodeList,
        })
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.removeCheckBox()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    openFeeDetailDialog(soBillDetailCode, price, type) {
      if (price) {
        this.feeDialogOption.soBillDetailCode = soBillDetailCode
        this.feeDialogOption.dialogVisible = true
        this.feeDialogOption.title =
          type === 'A' ? '额外收入费用' : '额外支出费用'
        this.feeDialogOption.show = false
        this.feeDialogOption.type = type
      }
    },
    close() {
      this.feeDialogOption = {
        soStatementCode: '',
        soStatementCodeList: [],
        dialogVisible: false,
        title: '',
        show: true,
        type: '',
      }
    },
    removeCheckBox() {
      // 清除选中的记录
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
    },
    showFeeDetail(row) {
      const feeList = row.feeList
      if (!feeList || feeList.length == 0) {
        return
      }
      let content = ''
      feeList.forEach((item) => {
        let feeName = item.feeName
        let price = item.price
        content += '<strong>' + feeName + '：<i>' + price + '</i></strong><br/>'
      })
      this.$alert(content, '其他额外费用', {
        dangerouslyUseHTMLString: true,
      })
    },
  },
}
</script>
